import { render, staticRenderFns } from "./CountriesEdit.vue?vue&type=template&id=50235ae9&"
import script from "./CountriesEdit.vue?vue&type=script&lang=js&"
export * from "./CountriesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports